import { LoginUser } from "@/features/account/components/login/login-user";

function Login() {
    return <LoginUser />;
}

export default Login;
